// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"9090dbd8","236":"63869be1","387":"1ea512f2","666":"2d83e571"}[chunkId] + ".chunk.css";
};